import {
  FieldMappingPhoneListField,
  FieldMappingPhoneListFieldProps,
} from '@components/field-mapping-phone-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingPhoneListFieldProps<T = unknown> = FormFieldProps<
  FieldMappingPhoneListFieldProps,
  T
>;

export function FormFieldMappingPhoneListField<T>(props: FormFieldMappingPhoneListFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping-list' });

  return <FieldMappingPhoneListField {...props} {...formFieldProps} />;
}
